/* eslint-disable */ import { attachSingleReferenceComponent, referenceComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { AnchorableShape } from '../model/index.js';
export const anchorPointComponents = [
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'AnchorPoint.$shape', true).withEntity('AnchorPoint'), AnchorableShape, 'shapeId')
];

//# sourceMappingURL=anchor-point.js.map